import { render } from "./OrderPartEditProduct.vue?vue&type=template&id=74140d12&scoped=true"
import script from "./OrderPartEditProduct.vue?vue&type=script&lang=js"
export * from "./OrderPartEditProduct.vue?vue&type=script&lang=js"

import "./OrderPartEditProduct.vue?vue&type=style&index=0&id=74140d12&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74140d12"]])

export default __exports__